module.exports = __webpack_public_path__ + "media/site_templates/www.localcleaners.net.au/images/feature_3-cfb3e778668abf599c72449771d71562.jpeg";